<template>
  <div>
    <failed-payment-notification-bar/>
    <div class="account-settings">
      <subscription-settings/>
      <account-setting-button :title="'הוספת שותפ.ה למנוי'" :action="addMember"/>
      <account-setting-button :title="'סגירת חשבון ומחיקת פרטים'" :action="openChurnFlow" :color="'red'"/>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import ModalBus from '@/event-bus/modal-bus';
import ChurnDescriptionPopup from '@/pages/responsive-pages/authenticated/churn/ChurnDescriptionPopup';
import AccountSettingButton
  from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/components/AccountSettingButton';
import SubscriptionSettings from './SubscriptionSettings.vue';
import Segment from '../../../../../Segment';
import FailedPaymentNotificationBar from './components/FailedPaymentNotificationBar.vue';

export default {
  name: 'account-settings',
  components: {
    FailedPaymentNotificationBar,
    SubscriptionSettings,
    AccountSettingButton,
  },
  created() {
    Segment.trackUserGot('AccountSettingsEntered');
  },
  methods: {
    addMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      router.push({ path: '/invite-member', query: this.$route.query });
    },
    openChurnFlow() {
      Segment.trackUserInteraction('ChurnButtonClicked');
      ModalBus.$emit('open', {
        component: ChurnDescriptionPopup,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../scss/mixins';
  .account-settings {
    @include responsive-padding;
    padding-top: 17px;
  }

</style>
